import { customerApi } from "../../utils/apiConfig";
const getAuthHeaders = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});
export const uploadRuloFormat = (userId, file) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("excel", file);

  return customerApi.post("/uploadRuloFormat", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const sendStockMailFormat = (email, groupedData, tag) => {
  return customerApi.post(
    "/sendStockMailFormat",
    { email, groupedData, tag },
    getAuthHeaders()
  );
};

export const createCustomerMail = (data) => {
  return customerApi.post("/createCustomerMail", data, getAuthHeaders());
};

export const getCustomerMailList = (filters = {}) => {
  return customerApi.post("/getCustomerMailList", filters, getAuthHeaders());
};

export const getCustomerMailDetail = (id) => {
  return customerApi.get(`/getCustomerMailDetail/${id}`, getAuthHeaders());
};

export const updateCustomerMail = (id, data) => {
  return customerApi.post(`/updateCustomerMail/${id}`, data, getAuthHeaders());
};

export const deleteCustomerMail = (id) => {
  return customerApi.post(`/deleteCustomerMail/${id}`, getAuthHeaders());
};

export const getCustomerMailSendLogs = (filters = {}) => {
  return customerApi.post(
    "/getCustomerMailSendLogs",
    filters,
    getAuthHeaders()
  );
};
